<template>
  <div
    ref="contextMenu"
    v-click-outside="hideContextMenu"
    class="context-menu"
    :style="contextMenuStyles"
    @click="hideContextMenu">
    <ul class="context-actions">
      <div
        v-for="(actions, index) in dynamicActions"
        :key="index"
        class="delimiter">
        <li
          v-for="dynamicAction in actions"
          :key="dynamicAction.id"
          :class="{ inactive: isActionDisabled(dynamicAction) }">
          <span
            :class="[dynamicAction.id]"
            :title="dynamicAction.title"
            @click="!isActionDisabled(dynamicAction) && dynamicAction.action(ids)">
            <em :class="[dynamicAction.icon, dynamicAction.variant]" />
            <span class="context">{{ dynamicAction.title }}</span>
          </span>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'ContextMenu',
  props: {
    contextEvent: {
      type: Event,
      default: null,
    },
    dynamicActions: {
      type: Array,
      default: () => [],
    },
    ids: {
      type: Array,
      required: true,
    },
  },
  emits: ['hide'],
  data() {
    return {
      contextMenuStyles: {
        top: 0,
        left: 0,
        opacity: 0,
      },
    };
  },
  watch: {
    contextEvent: {
      deep: true,
      handler() {
        this.getContextMenuPosition();
      },
    },
  },
  mounted() {
    this.getContextMenuPosition();
  },
  methods: {
    isActionDisabled(action) {
      return Object.hasOwn(action, 'active') && !action.active;
    },
    getContextMenuPosition: debounce(function () {
      let { clientX: left, clientY: top } = this.contextEvent;
      const { width, height } = this.$refs.contextMenu.getBoundingClientRect();

      const freePlaceX = window.innerWidth - left;
      const freePlaceY = window.innerHeight - top;

      if (width > freePlaceX) {
        if (left - width > 0) {
          left -= width;
        } else {
          left = 0;
        }
      }

      if (height > freePlaceY) {
        if (top - height > 0) {
          top -= height;
        } else {
          top = 0;
        }
      }

      this.contextMenuStyles = {
        top: `${top}px`,
        left: `${left}px`,
        opacity: 1,
      };
    }, 100),
    hideContextMenu() {
      this.$emit('hide');
    },
  },
};
</script>

<style lang="scss" scoped>
.context-menu {
  visibility: visible;
  font-size: 17px;
  background-color: $white;
  min-width: initial;
  border-radius: 4px;
  position: fixed;
  height: auto;
  line-height: 23px;
  padding: 0;
  color: $icon-grey;
  float: left;
  border: 1px solid $gray-300;
  box-shadow: 0 4px 20px rgba(48, 49, 50, 0.2); // $gray-700
  z-index: 1000;
  .context-actions {
    list-style-type: none;
    > li:visible {
      padding: 3px 0;
    }
    li {
      &:hover {
        background-color: $b-05;
      }
      &:first-child {
        margin-top: 7px;
      }
      &:last-child {
        margin-bottom: 7px;
      }

      span {
        padding-right: 10px;
        cursor: pointer;
      }

      &.inactive {
        > span {
          color: $gray-400 !important;
        }
      }

      > span {
        line-height: 1;
        padding-left: 15px;
        padding-top: 4px;
        padding-bottom: 4px;
        color: $base-blue;
        display: flex;
        .danger,
        .danger + .context {
          color: $red !important;
        }
      }
    }
  }
  span.context {
    font-size: 15px;
    line-height: 24px;
    padding-left: 8px;
    display: inline-block;
    vertical-align: top;
    color: $base-grey;
    font-family: $regular-font;
    -webkit-font-smoothing: antialiased;
  }
  .fa:before {
    display: inline-block;
    width: 24px;
  }
  .delimiter:not(:last-child) {
    border-bottom: 1px solid $gray-200;
  }
}
</style>
